import { ReactNode } from "react";

/**
 * Creates custom cell renderers for the organic job delivery vacancy table.
 * The vacancyTitle cell is clickable and opens the vacancy drawer.
 */
export function createOrganicCellRenderers(
  onTitleClick?: (row: unknown) => void
): Record<string, (value: unknown, row: unknown) => ReactNode> {
  const renderers: Record<string, (value: unknown, row: unknown) => ReactNode> = {};

  renderers.vacancyTitle = (value: unknown, row: unknown): ReactNode => {
    const title = String(value ?? "-");
    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      if (onTitleClick) {
        onTitleClick(row);
      }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (onTitleClick) {
          onTitleClick(row);
        }
      }
    };

    return (
      <span
        className="text-primary cursor-pointer hover:underline"
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        {title}
      </span>
    );
  };

  return renderers;
}
